import { useState, useLayoutEffect, useRef, useCallback, useMemo } from 'react';
import gsap from 'gsap';
import './vendorProfile.css';
import { followUnfollowDetails, getMyProfileDetails, notificationCounts, getVendorLoyalty, getVendorProfileDetails, getSearchFilter, getVendorServiceDetailsNode, getMerchantHistoryNode, getVendorProductsNode } from '../../Services/api';
import { useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import p_closed_alert from '../../Assets/Images/p_closed_alert.svg';
import p_hours_dot from '../../Assets/Images/p_hours_dot.svg';
import p_hours_now from '../../Assets/Images/p_hours_now.svg';
import p_hours_check from '../../Assets/Images/p_hours_check.svg';
import ic_svc from '../../Assets/Images/offering/svc-idle.svg';
import ic_prod from '../../Assets/Images/offering/prod-idle.svg';
import ic_store from '../../Assets/Images/offering/store-idle.svg';
import ic_home from '../../Assets/Images/offering/home-idle.svg';
import ic_pickup from '../../Assets/Images/offering/pickup-idle.svg';
import ic_delivery from '../../Assets/Images/offering/delivery-idle.svg';
import ic_dinein from '../../Assets/Images/offering/dinein-idle.svg';
import ic_loyalty from '../../Assets/Images/p_loyalty_medal.png';
import p_navbars from '../../Assets/Images/p_navbars.svg';
import p_nav_search from '../../Assets/Images/p_nav_search.svg';
import p_search_location from '../../Assets/Images/p_search_location.svg';
import p_nav_location from '../../Assets/Images/p_nav_location.svg';
import p_nav_next_outline from '../../Assets/Images/p_nav_next_outline.svg';
import p_nav_book_outline from '../../Assets/Images/p_nav_book_outline.svg';
import p_nav_message_outline from '../../Assets/Images/p_nav_message_outline.svg';
import p_nav_notifications_outline from '../../Assets/Images/p_nav_notifications_outline.svg';
import p_nav_about_outline from '../../Assets/Images/p_nav_about_outline.svg';
import p_nav_setting_outline from '../../Assets/Images/p_nav_setting_outline.svg';
import { toast } from 'react-toastify';
import { showToast } from '../../Components/toastConfig/ToastConfig';
import hubIcon from "../../Assets/Images/icons/hub_icons.png"
import Lottie from "lottie-react";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from "react-redux";
import PingleFooter from '../../Components/Footer/pingleFooter';
import CenterLoginNavigateModal from '../../Components/modal/centerSmallModal';
import GuestUserSideBar from '../../Components/SideBar/guestUser_sideBar';

const VendorProfile = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const valueParam = useParams();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);

    const [profile, setProfile] = useState();
    const [profileData, setProfileData] = useState('');
    const [merchantId, setMerchantId] = useState();
    const [followStatus, setFollowStatus] = useState(0);
    const [followShowMessage, setFollowShowMessage] = useState('');
    const [notificationcount, setNotificationcount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(false);
    const [copied, setCopied] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [loyalty, setLoyalty] = useState()
    const [showSidebar, setShowSidebar] = useState(false);
    const toggleSidebar = () => {
        setShowSidebar(!showSidebar)
    }
    const handleShow = () => setShowModal(!showModal);



    useEffect(() => {
        if (userData?.user_type == "User") {
            getMyProfileDetails().then((res) => {
                setProfileData(res.data?.user_details);

            });

            getVendorProfileDetails(valueParam).then((res) => {

                setProfile(res.data);
                setMerchantId(res.data.vendor_id);
                setFollowStatus(res.data.follow_status);
                setFollowShowMessage(res.data.follow_show_message);
            }).catch((error) => {


            });

            getNotificationsCount()
            getVendorLoyalty(valueParam).then((res) => {
                setLoyalty(res.data)

            })
        } else {

            getVendorProfileDetails(valueParam).then((res) => {

                setProfile(res.data);
                setMerchantId(res.data.vendor_id);
                setFollowStatus(res.data.follow_status);
                setFollowShowMessage(res.data.follow_show_message);
            }).catch((error) => {

            });

        }

        localStorage.setItem("vendorUrl", location.pathname);

        ["serviceDetail", "serviceAdded", "productAdded", "EditOrder_Detail", "localStorageserviceTime",
            "shipping_type", "productDeliveryTime", "cartid", "appliedCard",
            "cart_items", "productCart", "additionalNotes", "audioDuration", "fromPage",
            "deliveryInstructions", "recordedAudio", "recordedAudioUrl", "recoredURL"
        ].forEach((key) => localStorage.removeItem(key));

        sessionStorage.removeItem("membership");

        let check = localStorage.getItem('login')
        if (check == 'Register') {
            localStorage.setItem("login", "logged");
        }

        setTimeout(() => {
            setPageLoaded(true)
        }, 2000);
    }, []);

    useEffect(() => {
        const fetchSelectedLocation = async () => {
            if (userData?.token) {
                try {
                    if (localStorage.getItem("selectedLocation")) {
                        let location = JSON.parse(localStorage.getItem("selectedLocation"));
                        setSelectedLocation(location);
                    } else {
                        let res = await getSearchFilter()
                        if (res?.status == 200) {
                            let selected = res.data?.selected_location ? res.data?.selected_location.address : 'Coimbatore'
                            setSelectedLocation(selected)
                        }
                    }
                } catch (err) {
                    if (err?.response?.status == 400 || err?.response?.status == 500) {
                        showToast(err.response || "Something went wrong, please try again later", "error");
                    }
                }
            } else {
                if (localStorage.getItem("selectedLocation")) {
                    let location = JSON.parse(localStorage.getItem("selectedLocation"));
                    setSelectedLocation(location);
                }
            }
        }

        fetchSelectedLocation();
    }, [userData?.token])

    function removeExtraFadeFromOffcanvas() {
        const myOffcanvas = document.getElementById('offcanvasTop');
        myOffcanvas.addEventListener('shown.bs.offcanvas', event => {
            let fade = document.getElementsByClassName('offcanvas-backdrop fade show')
            for (let i = 0; i < fade.length; i++) {
                while (fade.length > 1) {
                    fade[i].remove()
                }
            }
        });
    }

    function truncateString(str, maxLength) {
        if (str.length > maxLength) {
            return str.slice(0, maxLength) + '...';
        } else {
            return str;
        }
    }

    useEffect(() => { }, [followStatus, followShowMessage]);
    function openMap(lat, lng, id) {
        const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat}%${lng}&query_place_id=${id}`
        window.open(mapsUrl, '_blank');
    }

    const setServiceDetails = (serviceType, vendorId, isStaff) => {
        let serviceDetail = {
            'serviceType': serviceType,
            'vendorId': vendorId
        }
        localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));

        if (isStaff) {
            localStorage.setItem('selectedServiceOption', 'staff');
            navigate(`/select-staff/${vendorId}`)
        } else {
            localStorage.setItem('selectedServiceOption', 'service');
            navigate(`/door-step-service/${vendorId}`)
        }
    }

    const selectLocation = () => {
        navigate("/AddAddress", { state: { fromPage: 'profile' } })
    }
    const handelVendortype = () => {
        let vendortype = {
            vendor_type: profile?.vendor_profile?.vendor_details?.vendor_type_name
        }
        localStorage.setItem('vendortype', JSON.stringify(vendortype));
    }
    const setProductDetails = (shipping_type, vendorId) => {
        // let productDetail = {
        // 'shipping_type': shipping_type
        // }
        // localStorage.setItem('shipping_type', JSON.stringify(productDetail));
        // navigate(`/products/${vendorId}`)

        handelVendortype()
        let productDetail = {
            'shipping_type': shipping_type,
        }

        let cardDetail = {
            cardStatus: "",
            cardType: "",
            cardId: "",
        }

        let productCart = {
            shipping_type: shipping_type,
            cartId: "",
            vendorId: vendorId,
        }

        localStorage.setItem('productCart', JSON.stringify(productCart));
        localStorage.setItem('appliedCard', JSON.stringify(cardDetail));
        localStorage.setItem('shipping_type', JSON.stringify(productDetail));
        navigate(`/products/${vendorId}`)
    }

    const handleFollow = () => {

        if (userData?.user_type != "User") {
            handleShow();
            return
        }

        let param = {
            "follow_status": followStatus ? (followStatus == '1' ? '0' : '1') : '1',
            ...valueParam
        }

        followUnfollowDetails(param).then((res) => {
            setFollowStatus(res.data.follow_status)
            setFollowShowMessage(res.data.follow_show_message)
            toast(String(res.data.follow_status) === '1'
                ? `Following ${v?.vendor_company_name || 'this store'}`
                : 'Unfollowed', {
                position: 'bottom-center', autoClose: 2000, hideProgressBar: true,
                closeOnClick: true, theme: 'light', className: 'toast-style-1',
            });
        });
    }

    // native share sheet where the device offers one, otherwise the existing copy-link path
    const shareVendor = async () => {
        const url = profile?.profile_merchant_share_url;
        if (!url) return;
        if (navigator.share) {
            try {
                await navigator.share({ title: `${v?.vendor_company_name || 'Pingle'} on Pingle`, url });
                return;
            } catch (err) {
                if (err && err.name === 'AbortError') return;   // user dismissed the sheet
            }
        }
        copyToClipboard();
    };

    const copyToClipboard = () => {
        const textToCopy = profile.profile_merchant_share_url;
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, 99999);
        document.execCommand('copy');
        document.body.removeChild(textarea);
        setCopied(true);

        toast('Link copied!', {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            className: 'text-danger toast-style-1'
        });

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    const getNotificationsCount = () => {
        notificationCounts().then((res) => {
            setNotificationcount(res.data);
        });
    }

    /* ==================================================================
       Redesigned vendor page: offerings panel, hero carousel and motion.
       Motion runs through GSAP; durations collapse to 0 under
       prefers-reduced-motion. All data/handlers above are unchanged.
       ================================================================== */
    const REDUCE = useMemo(() => window.matchMedia('(prefers-reduced-motion: reduce)').matches, []);
    const dur = useCallback((s) => (REDUCE ? 0 : s), [REDUCE]);
    const flagOn = (x) => Number(x) === 1;
    const CAROUSEL_INTERVAL = 4000;

    const v = profile?.vendor_profile?.vendor_details;
    const vendorId = v?.vendor_id;
    const gallery = profile?.vendor_profile?.gallery_details || [];
    const workingHours = profile?.vendor_profile?.working_hours || [];

    const dayEntry = useCallback((offset) => {
        if (!workingHours.length) return null;
        const d = new Date();
        d.setDate(d.getDate() + offset);
        const name = d.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase().slice(0, 3);
        return workingHours.find((h) => String(h.day || '').toLowerCase().slice(0, 3) === name) || null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workingHours]);

    const todayHours = useMemo(() => dayEntry(0), [dayEntry]);
    const closedToday = !!todayHours?.day_status;

    // only promise "opens <day> <time>" when the next open day's timing can actually be read
    const opensNext = useMemo(() => {
        if (!closedToday) return null;
        for (let i = 1; i <= 7; i += 1) {
            const entry = dayEntry(i);
            if (!entry || entry.day_status) continue;
            const open = String(entry.timing || '').split(/[-–—]/)[0].trim();
            return open ? { when: i === 1 ? 'tomorrow' : entry.day, time: open } : null;
        }
        return null;
    }, [closedToday, dayEntry]);

    const closedMessage = opensNext
        ? `Closed today · opens ${opensNext.when} ${opensNext.time}`
        : (todayHours?.day_status_msg || 'Closed today');

    // the logo isn't always nested under vendor_details depending on the endpoint
    const vendorLogo = v?.vendor_logo || profile?.vendor_profile?.vendor_logo || profile?.vendor_logo || '';

    /* ---- working hours card (Figma "1 · Open all week", node 101:246) ----
       The API gives a free-text `timing` per day, so everything below degrades
       gracefully: if a range can't be parsed we show the raw string and simply
       omit the timeline rather than drawing a bar at a guessed position. */
    const parseHour = (str) => {
        const m = String(str || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?/i);
        if (!m) return null;
        let h = Number(m[1]);
        const min = Number(m[2] || 0);
        const ap = (m[3] || '').toLowerCase().replace(/\./g, '');
        if (ap === 'pm' && h !== 12) h += 12;
        if (ap === 'am' && h === 12) h = 0;
        return h > 24 || min > 59 ? null : h + min / 60;
    };
    const parseRange = (timing) => {
        const parts = String(timing || '').split(/\s*(?:[-–—]|to)\s*/i);
        if (parts.length < 2) return null;
        const start = parseHour(parts[0]);
        const end = parseHour(parts[1]);
        return start === null || end === null || end <= start ? null : { start, end };
    };
    const fmtHour = (h) => {
        const hh = Math.floor(h);
        const mm = Math.round((h - hh) * 60);
        const ap = hh >= 12 && hh < 24 ? 'PM' : 'AM';
        const h12 = hh % 12 || 12;
        return mm ? `${h12}:${String(mm).padStart(2, '0')} ${ap}` : `${h12} ${ap}`;
    };

    const todayRange = useMemo(
        () => (closedToday ? null : parseRange(todayHours?.timing)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [todayHours, closedToday]
    );

    const nowFraction = useMemo(() => {
        const n = new Date();
        return (n.getHours() + n.getMinutes() / 60) / 24;
    }, []);

    // null when today's range can't be read, so the UI falls back instead of guessing
    const openNow = useMemo(() => {
        if (closedToday) return false;
        if (!todayRange) return null;
        const h = nowFraction * 24;
        return h >= todayRange.start && h < todayRange.end;
    }, [closedToday, todayRange, nowFraction]);

    const todayLabel = useMemo(
        () => `Today, ${new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' })}`,
        []
    );

    // Monday-first week strip, matching the design's M T W T F S S order
    const weekStrip = useMemo(() => {
        const today = new Date();
        const monday = new Date(today);
        monday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
        return Array.from({ length: 7 }, (_, i) => {
            const d = new Date(monday);
            d.setDate(monday.getDate() + i);
            const full = d.toLocaleDateString('en-US', { weekday: 'long' });
            const entry = workingHours.find(
                (h) => String(h.day || '').toLowerCase().slice(0, 3) === full.toLowerCase().slice(0, 3)
            );
            return {
                key: full,
                letter: full.charAt(0),
                date: d.getDate(),
                isToday: d.toDateString() === today.toDateString(),
                closed: !!entry?.day_status,
            };
        });
    }, [workingHours]);

    const hoursNote = useMemo(() => {
        if (!workingHours.length) return null;
        const open = workingHours.filter((h) => !h.day_status);
        if (!open.length) return 'Closed all week';
        const uniform = open.every((h) => h.timing === open[0].timing);
        if (open.length === 7 && uniform) return 'Open all 7 days, same hours';
        const closed = workingHours.filter((h) => h.day_status).map((h) => h.day);
        if (closed.length && uniform) return `Same hours daily · closed ${closed.join(', ')}`;
        return `Open ${open.length} ${open.length === 1 ? 'day' : 'days'} a week · hours vary`;
    }, [workingHours]);

    const serviceModes = useMemo(() => {
        if (!v || !flagOn(v.vendor_status) || !flagOn(v.service_status)) return [];
        const modes = [];
        if (flagOn(v.instore_service_status)) modes.push({ key: 'instore', label: 'In-store', cta: 'Book in-store' });
        if (flagOn(v.subscription_status) && flagOn(v.doorstep_status)) modes.push({ key: 'doorstep', label: 'Doorstep', cta: 'Book doorstep' });
        return modes;
    }, [v]);

    const productModes = useMemo(() => {
        if (!v || !flagOn(v.vendor_status) || !flagOn(v.product_status)) return [];
        const modes = [];
        if (flagOn(v.instore_product_status)) modes.push({ key: 'pickup', label: 'Pickup', cta: 'Shop for pickup' });
        if (flagOn(v.product_delivery_status)) modes.push({ key: 'delivery', label: 'Delivery', cta: 'Shop for delivery' });
        if (Number(v.vendor_type_id) === 9 && flagOn(v.dinein_product_status)) modes.push({ key: 'dinein', label: 'Dine-in', cta: 'Order to table' });
        return modes;
    }, [v]);

    /* Secondary offerings, with the prototype's per-row icons and tints.
       Each keeps the route the old service cards used. */
    const ROW_ICON = {
        // the "My Cards" rows reuse the membership icons (defined below)
        preorder: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <rect x="3" y="4" width="18" height="17" rx="2" /><path d="M16 2v4M8 2v4M3 10h18M8 15h3" />
            </svg>
        ),
        membership: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <rect x="2" y="5" width="20" height="14" rx="2.5" /><path d="M2 10h20M6 15h4" />
            </svg>
        ),
        offers: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12V4a1 1 0 011-1h8l9 9-9 9-9-9z" /><circle cx="7.5" cy="7.5" r="1.5" />
            </svg>
        ),
        coupons: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 8a2 2 0 012-2h14a2 2 0 012 2v2a2 2 0 000 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 000-4z" />
                <path d="M9.5 14.5l5-5" />
                <circle cx="9.5" cy="9.5" r=".6" fill="currentColor" /><circle cx="14.5" cy="14.5" r=".6" fill="currentColor" />
            </svg>
        ),
        foodmembership: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 11h16M5 11a7 7 0 0114 0M3 15h18M5 19h14" />
            </svg>
        ),
    };
    ROW_ICON.mycards = ROW_ICON.membership;
    ROW_ICON.myfoodcards = ROW_ICON.foodmembership;

    const HUB_ICON = (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 2v7a2 2 0 002 2h0a2 2 0 002-2V2" /><path d="M7 2v20" />
            <path d="M21 15V2a5 5 0 00-5 5v6a2 2 0 002 2h3Zm0 0v7" />
        </svg>
    );

    const moreRows = useMemo(() => {
        if (!v || !profile) return [];
        const rows = [];
        if (String(v.pre_order_status) === '1') {
            rows.push({
                key: 'preorder', title: 'Pre-order', sub: 'Book event packages ahead',
                tint: '#fff1e7', color: '#f2711c', go: () => navigate(`/TicketList/${vendorId}`),
            });
        }
        if (String(v.membership_status) === '1') {
            rows.push({
                key: 'membership', title: 'Membership', sub: 'Flat savings on every visit',
                tint: '#f3effb', color: '#4e26a3',
                go: () => navigate(`/MembershipBuyNow/${profile.vendor_id}`, { state: { vendorId: profile.vendor_id, vendorName: v.vendor_company_name } }),
            });
            if (userData?.user_type === 'User') {
                // the old page's "My Cards" button
                rows.push({
                    key: 'mycards', title: 'My membership cards', sub: 'Your cards at this store',
                    tint: '#f3effb', color: '#4e26a3',
                    go: () => navigate('/VendorMembership', { state: { vendorId: profile.vendor_id, vendorName: v.vendor_company_name } }),
                });
            }
        }
        if (String(v.offers_status) === '1') {
            rows.push({
                key: 'offers', title: 'Offers', sub: 'Deals you can use today',
                tint: '#e8f6ee', color: '#1a8a4a',
                // same state as the old page: the offer list shows the vendor name as its heading
                go: () => { handelVendortype(); navigate(`/Offerlist/${vendorId}`, { state: { vendorId, flowParent: 'cartlist', vendorName: v.vendor_company_name } }); },
            });
        }
        if (String(v.coupon_status) === '1') {
            rows.push({
                key: 'coupons', title: 'Coupons', sub: 'Codes to save on your booking',
                tint: '#fdecf2', color: '#d6336c', go: () => navigate(`/Coupon_list/${vendorId}`, { state: { viewOnly: true } }),
            });
        }
        // Food membership / My food membership cards are hidden for now; set to true to show them again
        const SHOW_FOOD_ROWS = false;
        if (SHOW_FOOD_ROWS && Number(v.hub_status) === 1) {
            rows.push({
                key: 'foodmembership', title: 'Food membership', sub: 'Plans for regulars',
                tint: '#eaf1fe', color: '#3b6fd8',
                go: () => navigate(`/food-memberships/${profile.vendor_id}`, { state: { vendorId: profile.vendor_id, vendorName: v.vendor_company_name } }),
            });
            if (userData?.user_type === 'User') {
                // the old page's food "My Cards" button
                rows.push({
                    key: 'myfoodcards', title: 'My food membership cards', sub: 'Your plans at this store',
                    tint: '#eaf1fe', color: '#3b6fd8',
                    go: () => navigate('/my-food-memberships'),
                });
            }
        }
        return rows;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [v, vendorId, profile, userData?.user_type]);

    const [pick, setPick] = useState(null);      // 'service' | 'product'
    const [svcMode, setSvcMode] = useState(null);
    const [prodMode, setProdMode] = useState(null);
    const lit = pick || (serviceModes.length ? 'service' : 'product');

    const groups = useMemo(() => {
        const g = [];
        if (serviceModes.length) g.push({ key: 'service', label: 'Services', title: 'Book a service', modes: serviceModes, active: pick === 'service' ? svcMode : null });
        if (productModes.length) g.push({ key: 'product', label: 'Products', title: 'Shop products', modes: productModes, active: pick === 'product' ? prodMode : null });
        return g;
    }, [serviceModes, productModes, pick, svcMode, prodMode]);

    // "209 services · from ₹29" once the catalog resolves; mode names until then
    const groupSub = (groupKey) => {
        const stats = groupKey === 'service' ? svcStats : prodStats;
        const noun = groupKey === 'service' ? 'service' : 'product';
        const group = groups.find((g) => g.key === groupKey);
        const fallback = group ? group.modes.map((m) => m.label).join(' · ') : '';
        if (!stats || !stats.count) return fallback;
        const count = `${stats.count.toLocaleString('en-IN')} ${noun}${stats.count === 1 ? '' : 's'}`;
        return stats.from ? `${count} · from ₹${stats.from.toLocaleString('en-IN')}` : count;
    };

    const ctaFor = (groupKey, modeKey) =>
        groups.find((g) => g.key === groupKey)?.modes.find((m) => m.key === modeKey)?.cta || '';

    const runCta = (groupKey) => {
        if (!vendorId) return;
        if (groupKey === 'service') {
            if (svcMode === 'instore') setServiceDetails(1, vendorId, false);
            else if (svcMode === 'doorstep') setServiceDetails(2, vendorId, false);
        } else if (prodMode === 'pickup') setProductDetails(1, vendorId);
        else if (prodMode === 'delivery') setProductDetails(2, vendorId);
        else if (prodMode === 'dinein') setProductDetails('0', vendorId);
    };

    const showStaffLink = pick === 'service' && svcMode === 'instore'
        && userData?.user_type === 'User' && String(v?.staff_app_status) === '1';

    /* The offering sub-labels ("209 services · from ₹29") need catalog counts, which the
       profile endpoint doesn't carry. Fetched after first paint so they never delay the
       page; the label falls back to the mode names until (or unless) they resolve. */
    const [svcStats, setSvcStats] = useState(null);
    const [prodStats, setProdStats] = useState(null);

    useEffect(() => {
        if (!pageLoaded || !vendorId) return undefined;
        let cancelled = false;

        // walk an unknown-shaped payload and pull {count, from} off the priced items
        const summarise = (payload, idKey, priceKey) => {
            const prices = [];
            const walk = (node) => {
                if (!node || typeof node !== 'object') return;
                if (Array.isArray(node)) { node.forEach(walk); return; }
                if (node[idKey] !== undefined && node[idKey] !== null) {
                    const n = Number(String(node[priceKey] ?? '').replace(/[^\d.]/g, ''));
                    prices.push(Number.isFinite(n) && n > 0 ? n : null);
                }
                Object.values(node).forEach(walk);
            };
            walk(payload);
            if (!prices.length) return null;
            const real = prices.filter((n) => n !== null);
            return { count: prices.length, from: real.length ? Math.min(...real) : null };
        };

        if (serviceModes.length) {
            getVendorServiceDetailsNode({ vendor_id: vendorId, service_type: 1, cart_app_id: '' })
                .then((res) => { if (!cancelled) setSvcStats(summarise(res?.data?.services, 'service_id', 'service_price')); })
                .catch(() => { });
        }
        if (productModes.length) {
            getVendorProductsNode({ vendor_id: vendorId, shipping_type: 1, flow_type: 'ORDER' })
                .then((res) => { if (!cancelled) setProdStats(summarise(res?.data?.result, 'product_id', 'price')); })
                .catch(() => { });
        }
        return () => { cancelled = true; };
    }, [pageLoaded, vendorId, serviceModes.length, productModes.length]);

    const [aboutOpen, setAboutOpen] = useState(false);
    const [aboutClamped, setAboutClamped] = useState(false);
    const descRef = useRef(null);

    const rootRef = useRef(null);
    const slidesRef = useRef(null);
    const dotsRef = useRef(null);
    const offeringsRef = useRef(null);
    const spotRef = useRef(null);
    const groupRefs = useRef({});
    const dropRefs = useRef({});
    const ctaRefs = useRef({});
    const iconRefs = useRef({});
    /* Bookings sheet: the prototype slides previous bookings up over the page rather than
       navigating away, and keeps the History icon lit while it's open. */
    const [sheetOpen, setSheetOpen] = useState(false);
    const [historyRows, setHistoryRows] = useState(null);   // null = still loading
    const sheetRef = useRef(null);
    const sheetOverlayRef = useRef(null);
    const followBtnRef = useRef(null);
    const historyBtnRef = useRef(null);
    const shineRef = useRef(null);
    const hoursRef = useRef(null);
    const curSlide = useRef(0);
    const spotReady = useRef(false);
    const lastSpot = useRef({ y: NaN, h: NaN });

    // only offer "more" when the copy is actually clamped
    useLayoutEffect(() => {
        const el = descRef.current;
        if (!pageLoaded || !el || aboutOpen) return undefined;
        const check = () => setAboutClamped(el.scrollHeight > el.clientHeight + 1);
        check();
        window.addEventListener('resize', check);
        document.fonts?.ready.then(check).catch(() => { });
        return () => window.removeEventListener('resize', check);
    }, [pageLoaded, aboutOpen, v?.vendor_about]);

    // entrance: the first screen rises in once the data is ready
    useLayoutEffect(() => {
        if (!pageLoaded || !rootRef.current) return;
        const ctx = gsap.context(() => {
            gsap.utils.toArray('[data-rise]').forEach((b, i) => {
                gsap.fromTo(b,
                    { opacity: 0, y: b.dataset.rise === 'hero' ? 0 : 8 },
                    { opacity: 1, y: 0, duration: dur(.3), ease: 'power4.out', delay: dur(i * .06) });
            });
        }, rootRef);
        return () => ctx.revert();
    }, [pageLoaded, dur]);

    // hero carousel: auto-advance, dot width + fill countdown, photo fade-in
    useLayoutEffect(() => {
        const slides = slidesRef.current, dotsEl = dotsRef.current;
        if (!pageLoaded || !slides || gallery.length === 0) return;

        let timer = null, holding = false;
        const dots = dotsEl ? Array.from(dotsEl.children) : [];
        const fillTweens = [];

        const paint = (i) => {
            curSlide.current = i;
            dots.forEach((d, k) => {
                const on = k === i;
                d.setAttribute('aria-current', String(on));
                gsap.to(d, { width: on ? 18 : 5, duration: dur(.3), ease: 'power2.out', overwrite: 'auto' });
                fillTweens[k]?.kill();
                const fill = d.querySelector('.vp-fill');
                if (!fill) return;
                gsap.set(fill, { scaleX: 0 });
                if (on && !REDUCE) fillTweens[k] = gsap.to(fill, { scaleX: 1, duration: CAROUSEL_INTERVAL / 1000, ease: 'none' });
            });
        };
        const go = (i) => slides.scrollTo({ left: i * slides.clientWidth, behavior: REDUCE ? 'auto' : 'smooth' });
        const schedule = () => {
            clearTimeout(timer);
            if (REDUCE || holding || document.hidden) return;
            timer = setTimeout(() => go((curSlide.current + 1) % gallery.length), CAROUSEL_INTERVAL);
        };
        const onScroll = () => {
            const i = Math.round(slides.scrollLeft / slides.clientWidth);
            if (i !== curSlide.current) { paint(i); schedule(); }
        };
        const hold = () => { holding = true; clearTimeout(timer); fillTweens[curSlide.current]?.pause(); };
        const release = () => { holding = false; paint(curSlide.current); schedule(); };
        const onVisibility = () => (document.hidden ? clearTimeout(timer) : (paint(curSlide.current), schedule()));
        const dotClick = (i) => () => go(i);
        const dotHandlers = dots.map((d, i) => { const h = dotClick(i); d.addEventListener('click', h); return h; });

        slides.addEventListener('scroll', onScroll, { passive: true });
        slides.addEventListener('pointerdown', hold);
        ['pointerup', 'pointercancel', 'touchend'].forEach((e) => slides.addEventListener(e, release, { passive: true }));
        document.addEventListener('visibilitychange', onVisibility);

        const imgs = Array.from(slides.querySelectorAll('img'));
        const shows = imgs.map((img) => {
            const show = () => gsap.to(img, { opacity: 1, duration: dur(.3), ease: 'power4.out' });
            if (img.complete) { show(); return null; }
            img.addEventListener('load', show, { once: true });
            img.addEventListener('error', show, { once: true });
            return show;
        });

        paint(0); schedule();

        return () => {
            clearTimeout(timer);
            fillTweens.forEach((t) => t?.kill());
            slides.removeEventListener('scroll', onScroll);
            slides.removeEventListener('pointerdown', hold);
            ['pointerup', 'pointercancel', 'touchend'].forEach((e) => slides.removeEventListener(e, release));
            document.removeEventListener('visibilitychange', onVisibility);
            dots.forEach((d, i) => d.removeEventListener('click', dotHandlers[i]));
            imgs.forEach((img, i) => { if (shows[i]) { img.removeEventListener('load', shows[i]); img.removeEventListener('error', shows[i]); } });
        };
    }, [pageLoaded, gallery.length, dur, REDUCE]);

    // the CTA drops down once a mode is picked
    useLayoutEffect(() => {
        if (!pageLoaded) return;
        groups.forEach((g) => {
            const drop = dropRefs.current[g.key], ctaBtn = ctaRefs.current[g.key];
            if (!drop || !ctaBtn) return;
            const open = !!g.active, inner = drop.firstElementChild;
            drop.inert = !open;
            gsap.to(drop, {
                height: open && inner ? inner.scrollHeight : 0,
                duration: dur(.4), ease: 'power4.out', overwrite: 'auto',
                onComplete: () => { if (open) drop.style.height = 'auto'; },
            });
            const delay = open ? dur(.08) : 0;
            gsap.to(ctaBtn, { opacity: open ? 1 : 0, duration: dur(.25), ease: 'power1.out', delay, overwrite: 'auto' });
            gsap.to(ctaBtn, { y: open ? 0 : -10, scale: open ? 1 : .98, duration: dur(.4), ease: open ? 'back.out(1.4)' : 'power2.in', delay, overwrite: 'auto' });
        });
    }, [groups, pageLoaded, dur]);

    // the purple spotlight slides to whichever offering is active
    const placeSpot = useCallback(() => {
        const offs = offeringsRef.current, spot = spotRef.current;
        if (!offs || !spot) return;
        const gap = parseFloat(getComputedStyle(offs).rowGap) || 0;
        let y = 0;
        for (const g of Array.from(offs.querySelectorAll('[data-og]'))) {
            const drop = g.querySelector('.vp-drop');
            const inner = drop?.firstElementChild;
            const open = g.dataset.open === '1';
            // predict the settled size so the purple doesn't chase the drop mid-animation
            const h = g.offsetHeight - (drop?.offsetHeight || 0) + (open && inner ? inner.scrollHeight : 0);
            if (g.dataset.og === lit) {
                // the observer below fires every frame while a drop animates, and the predicted
                // target is constant across those frames — retargeting each time would restart
                // the tween 60x/sec and stutter, so only move on a real change (>1px, to ride
                // out offsetHeight's integer rounding).
                if (Math.abs(y - lastSpot.current.y) < 1 && Math.abs(h - lastSpot.current.h) < 1) return;
                lastSpot.current = { y, h };
                if (spotReady.current) gsap.to(spot, { y, height: h, duration: dur(.42), ease: 'power3.inOut', overwrite: 'auto' });
                else gsap.set(spot, { y, height: h });
                return;
            }
            y += h + gap;
        }
    }, [lit, dur]);

    useLayoutEffect(() => {
        if (!pageLoaded) return;
        placeSpot();
        const offs = offeringsRef.current;
        if (!offs) return;
        const ro = new ResizeObserver(() => {
            placeSpot();
            offs.querySelectorAll('[data-open="1"] .vp-drop').forEach((d) => {
                if (!gsap.isTweening(d)) d.style.height = 'auto';
            });
        });
        ro.observe(offs);
        const raf = requestAnimationFrame(() => requestAnimationFrame(() => { spotReady.current = true; }));
        return () => { ro.disconnect(); cancelAnimationFrame(raf); };
    }, [pageLoaded, placeSpot, groups]);

    // the lit group's label and card lift onto the purple
    useLayoutEffect(() => {
        if (!pageLoaded) return;
        groups.forEach((g) => {
            const el = groupRefs.current[g.key];
            if (!el) return;
            const on = g.key === lit;
            const label = el.querySelector('.vp-og-label');
            const card = el.querySelector('.vp-offer');
            if (label) gsap.to(label, { color: on ? 'rgba(255,255,255,.85)' : '#6e6984', duration: dur(.3), overwrite: 'auto' });
            if (card) gsap.to(card, { boxShadow: on ? '0 8px 20px -10px rgba(20,8,60,.5)' : '0 1px 2px rgba(27,21,48,.05), 0 4px 16px rgba(27,21,48,.06)', duration: dur(.3), overwrite: 'auto' });
        });
    }, [groups, lit, pageLoaded, dur]);

    // press feedback + the flow-button flood
    useLayoutEffect(() => {
        if (!pageLoaded || !rootRef.current) return;
        const ctx = gsap.context(() => {
            const press = (sel, scale) => gsap.utils.toArray(sel).forEach((el) => {
                const down = () => gsap.to(el, { scale, duration: dur(.12), ease: 'power2.out', overwrite: 'auto' });
                const up = () => gsap.to(el, { scale: 1, duration: dur(.2), ease: 'power3.out', overwrite: 'auto' });
                el.addEventListener('pointerdown', down);
                ['pointerup', 'pointercancel', 'pointerleave'].forEach((e) => el.addEventListener(e, up));
            });
            press('.vp-act', .96); press('.vp-modes button', .97);
            press('.vp-cta', .97); press('.vp-redeem', .96); press('.vp-row', .99);

            gsap.utils.toArray('.vp-cta').forEach((btn) => {
                const circle = btn.querySelector('.vp-flow-circle');
                const arrIn = btn.querySelector('.vp-arr-in');
                const arrOut = btn.querySelector('.vp-arr-out');
                if (!circle || !arrIn || !arrOut) return;
                let flowing = false;
                const enter = () => {
                    if (flowing) return; flowing = true;
                    gsap.to(btn, { borderRadius: 16, duration: dur(.6), ease: 'power4.out', overwrite: 'auto' });
                    gsap.to(circle, { width: 420, height: 420, opacity: 1, duration: dur(.8), ease: 'power4.out', overwrite: 'auto' });
                    gsap.to(arrIn, { marginRight: 8, opacity: 1, x: 0, duration: dur(.55), ease: 'back.out(1.6)', overwrite: 'auto' });
                    gsap.to(arrOut, { marginLeft: -16, opacity: 0, x: 14, duration: dur(.55), ease: 'back.out(1.6)', overwrite: 'auto' });
                };
                const leave = () => {
                    if (!flowing) return; flowing = false;
                    gsap.to(btn, { borderRadius: 14, duration: dur(.6), ease: 'power2.out', overwrite: 'auto' });
                    gsap.to(circle, { width: 16, height: 16, opacity: 0, duration: dur(.8), ease: 'power2.out', overwrite: 'auto' });
                    gsap.to(arrIn, { marginRight: -16, opacity: 0, x: -14, duration: dur(.55), ease: 'power2.out', overwrite: 'auto' });
                    gsap.to(arrOut, { marginLeft: 8, opacity: 1, x: 0, duration: dur(.55), ease: 'power2.out', overwrite: 'auto' });
                };
                btn.addEventListener('pointerenter', enter);
                btn.addEventListener('pointerleave', leave);
                btn.addEventListener('focus', enter);
                btn.addEventListener('blur', leave);
            });
        }, rootRef);
        return () => ctx.revert();
    }, [pageLoaded, groups.length, moreRows.length, dur]);

    const pickMode = (groupKey, modeKey) => {
        if (groupKey === 'service') { setPick('service'); setSvcMode(modeKey); }
        else { setPick('product'); setProdMode(modeKey); }
        if (REDUCE) return;
        const icon = iconRefs.current[`${groupKey}:${modeKey}`];
        if (icon) {
            gsap.timeline()
                .to(icon, { scale: 1.28, duration: dur(.14), ease: 'power1.inOut' })
                .to(icon, { scale: .92, duration: dur(.14), ease: 'power1.inOut' })
                .to(icon, { scale: 1.14, duration: dur(.14), ease: 'power1.inOut' })
                .to(icon, { scale: 1, duration: dur(.28), ease: 'power1.inOut' });
        }
        const tile = iconRefs.current[`${groupKey}:tile`];
        if (tile) {
            gsap.timeline()
                .to(tile, { scale: 1.08, duration: dur(.128), ease: 'power1.out' })
                .to(tile, { scale: 1, duration: dur(.192), ease: 'power1.in' });
        }
    };

    const BOOK_STATUS = {
        '1': 'Yet to start', '2': 'Completed', '3': 'Cancelled',
        '4': 'Missed', '5': 'Yet to pay', '6': 'Expired',
    };
    const statusTone = (label) => (
        label === 'Completed' ? 'done' : (['Cancelled', 'Missed', 'Expired'].includes(label) ? 'cancel' : 'upcoming')
    );

    const loadHistory = useCallback(() => {
        setHistoryRows(null);
        getMerchantHistoryNode({ vendor_id: valueParam.vendor_id })
            .then((res) => {
                const details = res?.data?.history_details || [];
                const services = details[0]?.history || [];
                const products = details[1]?.history || [];
                const rows = [
                    ...services.map((it) => ({
                        key: `s-${it.booking_id}`,
                        id: it.booking_id,
                        kind: 'service',
                        title: 'Service booking',
                        when: [it.book_date, it.book_time].filter(Boolean).join(', '),
                        status: BOOK_STATUS[String(it.book_status)] || '',
                    })),
                    ...products.map((it) => ({
                        key: `p-${it.order_id}`,
                        id: it.order_id,
                        kind: 'product',
                        title: (it.order_products || []).map((pr) => pr.product_name || pr.name).filter(Boolean)[0] || 'Product order',
                        when: it.order_date_string || '',
                        status: BOOK_STATUS[String(it.order_status)] || '',
                    })),
                ];
                setHistoryRows(rows);
            })
            .catch(() => setHistoryRows([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueParam.vendor_id]);

    const closeSheet = useCallback(() => {
        const panel = sheetRef.current, ov = sheetOverlayRef.current;
        if (!panel || !ov) { setSheetOpen(false); return; }
        gsap.killTweensOf([panel, ov]);
        gsap.to(ov, { opacity: 0, duration: dur(.2), ease: 'power1.in' });
        gsap.to(panel, {
            x: '-50%', y: '100%', duration: dur(.32), ease: 'power2.in',
            onComplete: () => setSheetOpen(false),
        });
        paintActIconRef.current?.(historyBtnRef.current, false);
    }, [dur]);

    // animate in whenever the sheet mounts; Esc and the hardware back button close it
    useLayoutEffect(() => {
        if (!sheetOpen) return undefined;
        const panel = sheetRef.current, ov = sheetOverlayRef.current;
        if (panel && ov) {
            gsap.set(ov, { opacity: 0 });
            gsap.set(panel, { x: '-50%', y: '100%' });
            gsap.to(ov, { opacity: 1, duration: dur(.25), ease: 'power1.out' });
            gsap.to(panel, { x: '-50%', y: '0%', duration: dur(.4), ease: 'power3.out' });
        }
        const onKey = (e) => { if (e.key === 'Escape') closeSheet(); };
        document.addEventListener('keydown', onKey);
        document.documentElement.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.documentElement.style.overflow = '';
        };
    }, [sheetOpen, dur, closeSheet]);

    // the icon's coloured paths wipe in from the bottom while active (prototype: setActPressed)
    const paintActIcon = useCallback((btn, on, animate = true) => {
        if (!btn) return;
        const fill = btn.querySelectorAll('.vp-fill-path');
        const inner = btn.querySelectorAll('.vp-inner');
        if (!fill.length) return;
        const clip = on ? 'inset(0% 0% 0% 0%)' : 'inset(100% 0% 0% 0%)';
        if (!animate) {
            gsap.set(fill, { clipPath: clip, opacity: on ? 1 : 0 });
            if (inner.length) gsap.set(inner, { stroke: on ? '#ffffff' : '#1b1530' });
            return;
        }
        gsap.to(fill, { clipPath: clip, duration: dur(.5), ease: 'power2.out', overwrite: 'auto' });
        gsap.to(fill, { opacity: on ? 1 : 0, duration: dur(.15), ease: 'none', overwrite: 'auto' });
        if (inner.length) gsap.to(inner, { stroke: on ? '#ffffff' : '#1b1530', duration: dur(.25), delay: dur(.12), overwrite: 'auto' });
    }, [dur]);

    const paintActIconRef = useRef(null);
    useLayoutEffect(() => { paintActIconRef.current = paintActIcon; }, [paintActIcon]);

    // follow state owns the fill: paint instantly on first render, animate on change
    const followPainted = useRef(false);
    useLayoutEffect(() => {
        if (!pageLoaded) return;
        const on = String(followStatus) === '1';
        paintActIcon(followBtnRef.current, on, followPainted.current);
        followPainted.current = true;
    }, [followStatus, pageLoaded, paintActIcon]);

    // Follow / History / Share icon pops, ported from the prototype (ring · flip · pulse)
    const playActPop = (btn) => {
        if (REDUCE || !btn) return;
        const kind = btn.dataset.anim;
        if (kind === 'ring') {
            const ring = btn.querySelector('.vp-ring');
            if (!ring) return;
            gsap.timeline({ defaults: { duration: dur(.105), ease: 'power1.inOut' } })
                .to(ring, { rotate: 14 }).to(ring, { rotate: -12 }).to(ring, { rotate: 8 })
                .to(ring, { rotate: -5 }).to(ring, { rotate: 2 })
                .to(ring, { rotate: 0, duration: dur(.175) });
        } else if (kind === 'flip') {
            const ico = btn.querySelector('.vp-aico');
            if (!ico) return;
            gsap.set(ico, { transformPerspective: 300 });
            gsap.timeline()
                .to(ico, { rotationY: -28, y: -2, duration: dur(.2), ease: 'power2.out' })
                .to(ico, { rotationY: 0, y: 0, duration: dur(.3), ease: 'power2.inOut' });
        } else if (kind === 'pulse') {
            [['.vp-n2', 0], ['.vp-n1', .08], ['.vp-n3', .16]].forEach(([sel, delay]) => {
                const n = btn.querySelector(sel);
                if (n) gsap.to(n, { scale: 1.35, duration: dur(.225), ease: 'power1.inOut', yoyo: true, repeat: 1, delay: dur(delay), transformOrigin: 'center' });
            });
        }
    };

    const playShine = () => {
        const el = shineRef.current;
        if (!el || REDUCE) return;
        gsap.killTweensOf(el);
        gsap.fromTo(el, { x: '-160%', skewX: -20 }, { x: '330%', skewX: -20, duration: dur(.8), ease: 'power2.inOut' });
    };

    const MODE_ICON = {
        instore: ic_store, doorstep: ic_home,
        pickup: ic_pickup, delivery: ic_delivery, dinein: ic_dinein,
    };

    const vpChevron = (
        <svg className="vp-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 6l6 6-6 6" />
        </svg>
    );

    return (
        <>
            {
                pageLoaded ?
                    <>
                        <div className="d-flex justify-content-between align-items-center px-1 py-3 p-navbar bg-white offcanvas-parentType1">
                            {
                                userData?.user_type == "User"
                                    ?
                                    <div className="d-flex justify-content-between align-items-center ms-2 me-2 ">

                                        <div className="d-flex justify-content-between align-items-center" role='button' data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">
                                            <img src={p_navbars} width={'24px'} height={'16px'} role='button' data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} />

                                            <div
                                                className="ff-balooPaaji2-bold fs-20 ms-2 ps-1 text-dark text-truncate"
                                                style={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: '200px',
                                                }}
                                                title={profileData?.user_name}
                                            >
                                                {profileData?.user_name || "Guest"}
                                            </div>

                                        </div>

                                        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
                                            <div className="offcanvas-body p-0">
                                                <Link to={`/dashboard`} className="text-decoration-none">
                                                    <div className="profileDetails primary-bg p-3 text-white d-flex justify-content-between align-items-center">
                                                        <div className="d-flex">
                                                            <img src={profileData.user_img} width={'84px'} height={'81px'} />
                                                            <div className="ms-2">
                                                                <div className='ff-poppins-semiBold fs-16'>{profileData.user_name}</div>
                                                                <div className='ff-balooPaaji2-regular fs-12'>UID:{profileData.user_id}</div>
                                                                {profileData?.user_city &&
                                                                    <div className='ff-balooPaaji2-regular fs-12'>
                                                                        <img src={p_nav_location} width={'12px'} height={'12px'} className="me-1" />
                                                                        {profileData.user_city}
                                                                    </div>
                                                                }

                                                            </div>
                                                        </div>
                                                        <img src={p_nav_next_outline} width={'24px'} height={'24px'} />
                                                    </div>
                                                </Link>

                                                <div>
                                                    <Link to={`/`} className="text-decoration-none text-dark">
                                                        <div className="d-flex p-3" role="button" data-bs-dismiss="offcanvas" aria-label="Close">
                                                            <img src={p_nav_book_outline} width={'24px'} height={'24px'} />
                                                            <div className="ff-poppins-regular fs-16 ms-3">Bookings Manager</div>
                                                        </div>
                                                    </Link>
                                                    <Link to={`/messenger-list`} className="text-decoration-none text-dark" >
                                                        <div className="d-flex p-3" role="button">
                                                            <img
                                                                src={p_nav_message_outline}
                                                                width={"24px"}
                                                                height={"24px"}
                                                            />
                                                            <div className="d-flex justify-content-between w-100">
                                                                <div className="ff-poppins-regular fs-16 ms-3">Messenger</div>
                                                                <p className="">

                                                                    {notificationcount.unread_message_count > 0 ?
                                                                        <span className="notification_count">
                                                                            {notificationcount.unread_message_count >= 9 ? "9+" : notificationcount.unread_message_count}
                                                                        </span> : <></>
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                    <Link to={`/notifications`} className="text-decoration-none text-dark" >
                                                        <div className="d-flex sidebar p-3 " role="button">
                                                            <img src={p_nav_notifications_outline} width={"24px"} height={"24px"} />
                                                            <div className="d-flex justify-content-between w-100">
                                                                <div className="ff-poppins-regular fs-16 ms-3">
                                                                    Notification
                                                                </div>
                                                                <p className="">
                                                                    {notificationcount.unread_count > 0 ?
                                                                        <span className="notification_count">
                                                                            {notificationcount.unread_count >= 9 ? "9+" : notificationcount.unread_count}
                                                                        </span> : <></>
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                    <Link to={`/aboutPingle`} className="text-decoration-none text-dark">
                                                        <div className="d-flex p-3" role="button">
                                                            <img src={p_nav_about_outline} width={'24px'} height={'24px'} />
                                                            <div className="ff-poppins-regular fs-16 ms-3">About Pingle</div>
                                                        </div>
                                                    </Link>
                                                    <Link to={`/settings`} className="text-decoration-none text-dark">
                                                        <div className="d-flex p-3" role="button">
                                                            <img src={p_nav_setting_outline} width={'24px'} height={'24px'} />
                                                            <div className="ff-poppins-regular fs-16 ms-3">Settings</div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    userData?.user_type == "Guest"
                                        ?
                                        <div className="d-flex justify-content-between align-items-center ms-2 me-2" onClick={() => toggleSidebar()}>
                                            <img src={p_navbars} width={'24px'} height={'16px'} role='button' />

                                            <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1 text-dark'>
                                                Login
                                            </div>
                                        </div>
                                        :
                                        <Link to={`/login`} state={{ fromGuest: true }} className="text-decoration-none">
                                            <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                                                <img src={p_navbars} width={'24px'} height={'16px'} role='button' />

                                                <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1 text-dark'>
                                                    Login
                                                </div>
                                            </div>
                                        </Link>
                            }

                            {showSidebar &&
                                <GuestUserSideBar isOpen={showSidebar} user={userData} onClose={() => setShowSidebar(false)} />
                            }
                        </div>

                        <div className="vp scroller-style-y" ref={rootRef}>

                            {/* ---------- hero ---------- */}
                            {gallery.length > 0 && (
                                <div className="vp-hero" data-rise="hero">
                                    <div className="vp-slides" ref={slidesRef}>
                                        {gallery.map((item, index) => (
                                            <img key={index} src={item.img_name} alt={`${v?.vendor_company_name || 'Vendor'} ${index + 1}`}
                                                loading={index ? 'lazy' : undefined} />
                                        ))}
                                    </div>
                                    {gallery.length > 1 && (
                                        <div className="vp-dots" ref={dotsRef}>
                                            {gallery.map((_, index) => (
                                                <button key={index} type="button" aria-label={`Show photo ${index + 1} of ${gallery.length}`}>
                                                    <span className="vp-fill" />
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* ---------- identity ---------- */}
                            <div className="vp-info" data-rise="info">
                                {todayHours && !closedToday && (
                                    <div className="vp-status-row">
                                        <div className={`vp-open-now${openNow === false ? ' vp-shut' : ''}`}>
                                            {todayRange ? (
                                                <span>
                                                    <b className={openNow ? '' : 'vp-shut'}>{openNow ? 'Open now' : 'Closed'}</b>
                                                    {' · '}
                                                    <span>{openNow ? `Closes ${fmtHour(todayRange.end)}` : `Opens ${fmtHour(todayRange.start)}`}</span>
                                                </span>
                                            ) : <b>{`Today · ${todayHours.timing}`}</b>}
                                        </div>
                                    </div>
                                )}

                                <div className="vp-id-row">
                                    {vendorLogo && <img className="vp-logo" src={vendorLogo} alt="" width="56" height="56" />}
                                    <div>
                                        <h1>{v?.vendor_company_name}</h1>
                                        <div className="vp-meta">
                                            <span>{v?.vendor_cat_name}</span>
                                            {String(v?.vendor_city || '').trim() && (
                                                <><span className="vp-dot" /><span>{v.vendor_city.trim()}</span></>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* MID chip (click to copy) on the left, hub label on the right, below the vendor name */}
                                {(Number(v?.hub_status) === 1 || v?.vendor_id) && (
                                    <div className="vp-top-row">
                                        {v?.vendor_id && (
                                            <button type="button" className="vp-mid-chip" aria-label={`Copy MID ${v.vendor_id}`}
                                                onClick={() => {
                                                    const done = () => toast('MID copied', {
                                                        position: 'bottom-center', autoClose: 1500, hideProgressBar: true,
                                                        closeOnClick: true, theme: 'light', className: 'toast-style-1',
                                                    });
                                                    if (navigator.clipboard?.writeText) navigator.clipboard.writeText(String(v.vendor_id)).then(done).catch(() => { });
                                                    else done();
                                                }}>
                                                <span className="vp-mid-label">MID</span>
                                                <b className="vp-mid-value">{v.vendor_id}</b>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                                    <rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15V5a2 2 0 012-2h10" />
                                                </svg>
                                            </button>
                                        )}
                                        {Number(v?.hub_status) === 1 ? (
                                            <span className="vp-hub-pill">
                                                <img src={hubIcon} height="11" width="13" alt="" />
                                                {v?.hub_name?.match(/\d+$/)?.[0] ? `Hub ${v.hub_name.match(/\d+$/)[0]}` : (v?.hub_name || 'Hub')}
                                            </span>
                                        ) : null}
                                    </div>
                                )}

                                {closedToday && (
                                    <button className="vp-pinned-alert" type="button"
                                        onClick={() => hoursRef.current?.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' })}>
                                        <img className="vp-pa-icon" src={p_closed_alert} alt="" width="18" height="18" />
                                        <span className="vp-pa-msg">{closedMessage}</span>
                                        <span className="vp-pa-details">Details</span>
                                    </button>
                                )}

                                <div className="vp-actions">
                                    <button className="vp-act" type="button" data-anim="ring" ref={followBtnRef}
                                        onClick={(e) => { playActPop(e.currentTarget); handleFollow(); }}
                                        aria-pressed={String(followStatus) === '1'}>
                                        <svg className="vp-aico" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <g className="vp-ring">
                                                <path className="vp-fill-path" style={{ '--f': '#ffc24d' }} d="M14.5218 2.3423C14.0096 2.16285 13.4656 2.0496 12.9 2.01285C12.7024 2 12.4682 2 12 2C11.5317 2 11.2976 2 11.1 2.01285C8.06972 2.20977 5.65599 4.60304 5.45738 7.60758C5.44442 7.80358 5.44442 8.03572 5.44442 8.5V9.8056C5.44442 10.5353 5.44442 10.9002 5.40807 11.254C5.29504 12.354 4.9208 13.4119 4.31599 14.3409C4.12146 14.6397 3.89157 14.9246 3.43183 15.4944L3.26064 15.7066C2.80212 16.2749 2.57287 16.559 2.5228 16.789C2.4255 17.2359 2.64625 17.6913 3.05897 17.8951C3.27136 18 3.63835 18 4.37233 18H19.6277C20.3616 18 20.7286 18 20.941 17.8951C21.3537 17.6913 21.5745 17.2359 21.4772 16.789C21.4271 16.559 21.1979 16.2749 20.7394 15.7066L20.5682 15.4944C20.1898 15.0255 19.9672 14.7495 19.7918 14.5Z" />
                                                <path className="vp-fill-path" style={{ '--f': '#f58a2a' }} d="M16 18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18Z" />
                                                <path d="M16 18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M14.5218 2.3423C14.0096 2.16285 13.4656 2.0496 12.9 2.01285C12.7024 2 12.4682 2 12 2C11.5317 2 11.2976 2 11.1 2.01285C8.06972 2.20977 5.65599 4.60304 5.45738 7.60758C5.44442 7.80358 5.44442 8.03572 5.44442 8.5V9.8056C5.44442 10.5353 5.44442 10.9002 5.40807 11.254C5.29504 12.354 4.9208 13.4119 4.31599 14.3409C4.12146 14.6397 3.89157 14.9246 3.43183 15.4944L3.26064 15.7066C2.80212 16.2749 2.57287 16.559 2.5228 16.789C2.4255 17.2359 2.64625 17.6913 3.05897 17.8951C3.27136 18 3.63835 18 4.37233 18H19.6277C20.3616 18 20.7286 18 20.941 17.8951C21.3537 17.6913 21.5745 17.2359 21.4772 16.789C21.4271 16.559 21.1979 16.2749 20.7394 15.7066L20.5682 15.4944C20.1898 15.0255 19.9672 14.7495 19.7918 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15 7.99891H21M17.995 11.0039V5.00391" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                        </svg>
                                        <span>{followShowMessage ? followShowMessage : 'Follow'}</span>
                                    </button>

                                    <button className="vp-act" type="button" data-anim="flip" ref={historyBtnRef}
                                        onClick={(e) => {
                                            const btn = e.currentTarget;
                                            playActPop(btn);
                                            if (userData?.user_type != "User") { handleShow(); return; }
                                            paintActIcon(btn, true);   // stays lit while the sheet is open
                                            setSheetOpen(true);
                                            loadHistory();
                                        }}>
                                        <svg className="vp-aico" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path className="vp-fill-path" style={{ '--f': '#5b8def' }} d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" />
                                            <path className="vp-inner" d="M12 14H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path className="vp-inner" d="M12 18H7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M16 2V6M8 2V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path className="vp-inner" d="M3 10H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13 4H11C7.22876 4 5.34315 4 4.17157 5.17157C3 6.34315 3 8.22876 3 12V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12C21 8.22876 21 6.34315 19.8284 5.17157C18.6569 4 16.7712 4 13 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <span>History</span>
                                    </button>

                                    <button className="vp-act" type="button" data-anim="pulse"
                                        onClick={(e) => { playActPop(e.currentTarget); userData?.user_type == "User" ? shareVendor() : handleShow(); }}>
                                        <svg className="vp-aico" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path className="vp-node vp-n1" d="M21 6.5C21 8.15685 19.6569 9.5 18 9.5C16.3431 9.5 15 8.15685 15 6.5C15 4.84315 16.3431 3.5 18 3.5C19.6569 3.5 21 4.84315 21 6.5Z" stroke="currentColor" strokeWidth="1.5" />
                                            <path className="vp-node vp-n2" d="M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12Z" stroke="currentColor" strokeWidth="1.5" />
                                            <path className="vp-node vp-n3" d="M21 17.5C21 19.1569 19.6569 20.5 18 20.5C16.3431 20.5 15 19.1569 15 17.5C15 15.8431 16.3431 14.5 18 14.5C19.6569 14.5 21 15.8431 21 17.5Z" stroke="currentColor" strokeWidth="1.5" />
                                            <path d="M8.72852 10.7495L15.2285 7.75M8.72852 13.25L15.2285 16.2495" stroke="currentColor" strokeWidth="1.5" />
                                        </svg>
                                        <span>Share</span>
                                    </button>
                                </div>

                                {v?.vendor_address && (
                                    <div className="vp-loc-card">
                                        <svg className="vp-loc-map" viewBox="0 0 56 56" aria-hidden="true">
                                            <rect width="56" height="56" fill="#ecf1ea" />
                                            <path d="M-2 40 L58 22" stroke="#fff" strokeWidth="7" />
                                            <path d="M18 -2 L30 58" stroke="#fff" strokeWidth="5" />
                                            <path d="M40 -2 L46 58" stroke="#fff" strokeWidth="3" />
                                            <rect x="2" y="2" width="12" height="14" rx="2" fill="#d6e6cf" />
                                            <rect x="36" y="38" width="16" height="14" rx="2" fill="#dde3ec" />
                                            <path d="M28 41s-8-7.1-8-13.7a8 8 0 0116 0C36 33.9 28 41 28 41z" fill="#e5484d" />
                                            <circle cx="28" cy="27.5" r="3" fill="#fff" />
                                        </svg>
                                        <div className="vp-loc-text">
                                            <span className="vp-loc-link" role="button" tabIndex={0}
                                                onClick={() => openMap(v.vendor_lat, v.vendor_long, v.vendor_place_id)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') openMap(v.vendor_lat, v.vendor_long, v.vendor_place_id); }}>
                                                Get directions
                                            </span>
                                            <span className="vp-loc-addr">{v.vendor_address}{String(v.vendor_city || '').trim() ? `, ${v.vendor_city.trim()}` : ''}</span>
                                        </div>
                                        <span className="vp-loc-go" aria-hidden="true">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M21.7 11.3l-9-9a1 1 0 00-1.4 0l-9 9a1 1 0 000 1.4l9 9a1 1 0 001.4 0l9-9a1 1 0 000-1.4zM14 14.5V12h-4v3H8v-4a1 1 0 011-1h5V7.5l3.5 3.5z" />
                                            </svg>
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* ---------- offerings: pick what, then how ---------- */}
                            {groups.length > 0 && (
                                <div className="vp-offer-panel" data-rise="offerings">
                                    <h2 className="vp-op-title">Book or shop at {v?.vendor_company_name}</h2>
                                    <div className="vp-offerings" ref={offeringsRef}>
                                        <div className="vp-spot" ref={spotRef} aria-hidden="true" />
                                        {groups.map((g) => (
                                            <div className="vp-og" key={g.key} data-og={g.key} data-open={g.active ? '1' : '0'}
                                                ref={(el) => { groupRefs.current[g.key] = el; }}>
                                                <div className="vp-og-label">
                                                    <span>{g.label}</span>
                                                    <span>{groupSub(g.key)}</span>
                                                </div>
                                                <div className="vp-offer">
                                                    <div className="vp-offer-h">
                                                        <span className="vp-offer-ic" ref={(el) => { iconRefs.current[`${g.key}:tile`] = el; }}>
                                                            <i className="vp-mi" style={{ '--m': `url(${g.key === 'service' ? ic_svc : ic_prod})` }} aria-hidden="true" />
                                                        </span>
                                                        <h3>{g.title}</h3>
                                                    </div>

                                                    <div className="vp-modes" data-count={g.modes.length}>
                                                        {g.modes.map((m) => (
                                                            <button key={m.key} type="button"
                                                                aria-pressed={g.active === m.key}
                                                                onClick={() => pickMode(g.key, m.key)}
                                                                style={g.active === m.key ? { background: '#f3effc', borderColor: '#4e26a3' } : undefined}>
                                                                <i className="vp-mi" ref={(el) => { iconRefs.current[`${g.key}:${m.key}`] = el; }}
                                                                    style={{ '--m': `url(${MODE_ICON[m.key]})` }} aria-hidden="true" />
                                                                <b>{m.label}</b>
                                                            </button>
                                                        ))}
                                                    </div>

                                                    <div className="vp-drop" ref={(el) => { dropRefs.current[g.key] = el; }}>
                                                        <div>
                                                            <button className="vp-cta" type="button"
                                                                ref={(el) => { ctaRefs.current[g.key] = el; }}
                                                                onClick={() => runCta(g.key)}>
                                                                <span className="vp-flow-circle" aria-hidden="true" />
                                                                <span className="vp-flow-inner">
                                                                    <span className="vp-arr vp-arr-in">{vpChevron}</span>
                                                                    <span className="vp-flow-text">{ctaFor(g.key, g.active)}</span>
                                                                    <span className="vp-arr vp-arr-out">{vpChevron}</span>
                                                                </span>
                                                            </button>
                                                            {g.key === 'service' && showStaffLink && (
                                                                <button className="vp-ghost-link" type="button"
                                                                    onClick={() => setServiceDetails(1, vendorId, true)}>
                                                                    Choose a staff member instead
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* ---------- the rest of what this vendor offers ---------- */}
                            {moreRows.length > 0 && (
                                <section data-rise="more">
                                    <div className="vp-sec-h"><h2>More from this store</h2></div>
                                    <ul className="vp-list">
                                        {moreRows.map((r) => (
                                            <li key={r.key}>
                                                <button className="vp-row" type="button" onClick={r.go}>
                                                    <span className="vp-ic" style={{ background: r.tint, color: r.color }}>
                                                            {ROW_ICON[r.key]}
                                                        </span>
                                                    <span className="vp-txt"><b>{r.title}</b><small>{r.sub}</small></span>
                                                    {r.key === 'offers' && loyalty?.vendor_eligble_offers_count > 0 && (
                                                        <span className="vp-badge">{loyalty.vendor_eligble_offers_count} live</span>
                                                    )}
                                                    {vpChevron}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </section>
                            )}

                            {/* ---------- loyalty: only for vendors that run a loyalty programme ---------- */}
                            {Number(v?.vendor_status) === 1 && Number(v?.loyalty_status) === 1 && (
                                <section data-rise="loyalty">
                                    <div className="vp-loyalty">
                                        <img className="vp-medal" src={ic_loyalty} alt="" width="46" height="64" />
                                        <div className="vp-lt">
                                            <h2>Your loyalty points</h2>
                                            <p className="vp-pts"><b>{loyalty?.total_vendor_points ?? 0}</b> points</p>
                                        </div>
                                        <button className="vp-redeem" type="button"
                                            onPointerDown={playShine}
                                            onPointerEnter={(e) => { if (e.pointerType === 'mouse') playShine(); }}
                                            onClick={() => {
                                                if (userData?.user_type != "User") { handleShow(); return; }
                                                playShine();
                                                setTimeout(() => navigate(`/merchant-loyalty/${loyalty?.vendor_id}`), REDUCE ? 0 : 250);
                                            }}>
                                            Redeem {vpChevron}
                                            <span className="vp-shine" ref={shineRef} aria-hidden="true" />
                                        </button>
                                    </div>
                                </section>
                            )}

                            {/* ---------- hub bookings: one "Pingle foods" row, hub vendors only ---------- */}
                            {Number(v?.vendor_status) === 1 && Number(v?.hub_status) === 1 && (
                                <section data-rise="hub" aria-labelledby="vp-hub-h">
                                    <div className="vp-sec-h"><h2 id="vp-hub-h">Hub bookings</h2></div>
                                    <ul className="vp-list" role="list">
                                        <li>
                                            <button className="vp-row" type="button"
                                                onClick={() => { handelVendortype(); navigate(`/kitchen_ticket_list/${vendorId}`, { state: { vendorId, fromPage: 'vendorProfile' } }); }}>
                                                <span className="vp-ic" style={{ background: '#fde8e8', color: '#dc4b4b' }}>{HUB_ICON}</span>
                                                <span className="vp-txt">
                                                    <b>Pingle foods</b>
                                                    <small>Subscribe your daily food</small>
                                                </span>
                                                {vpChevron}
                                            </button>
                                        </li>
                                        <li>
                                            <button className="vp-row" type="button"
                                                onClick={() => navigate(`/food-memberships/${vendorId}`, { state: { vendorId, vendorName: v?.vendor_company_name } })}>
                                                <span className="vp-ic" style={{ background: '#eaf1fe', color: '#3b6fd8' }}>{ROW_ICON.foodmembership}</span>
                                                <span className="vp-txt">
                                                    <b>Pingle food memberships</b>
                                                    <small>Subscribe your daily food</small>
                                                </span>
                                                {vpChevron}
                                            </button>
                                        </li>
                                        {userData?.user_type === 'User' && (
                                            <li>
                                                <button className="vp-row" type="button" onClick={() => navigate('/my-food-memberships')}>
                                                    <span className="vp-ic" style={{ background: '#eaf1fe', color: '#3b6fd8' }}>{ROW_ICON.membership}</span>
                                                    <span className="vp-txt">
                                                        <b>My food membership cards</b>
                                                        <small>Your plans at this store</small>
                                                    </span>
                                                    {vpChevron}
                                                </button>
                                            </li>
                                        )}
                                    </ul>
                                </section>
                            )}

                            {/* ---------- captain ---------- */}
                            {profile?.vendor_profile?.contact_details?.contact_name && (
                                <section data-rise="captain" aria-label="Need help?">
                                    <div className="vp-captain">
                                        <span className="vp-ava">
                                            <img src={profile.vendor_profile.contact_details.contact_img} alt="" width="52" height="52" />
                                        </span>
                                        <div className="vp-cw">
                                            <span className="vp-eyebrow">Need help? Ask</span>
                                            <b>{profile.vendor_profile.contact_details.contact_name}</b>
                                        </div>
                                        <button className="vp-cap-btn" type="button"
                                            aria-label={`Message ${profile.vendor_profile.contact_details.contact_name}`}
                                            onClick={() => { userData?.user_type != "User" ? handleShow() : navigate(`/chat/${profile?.vendor_id}`) }}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M12 21a9 9 0 10-8.1-5.1L3 21l5.1-.9A9 9 0 0012 21z" /><path d="M8.5 10.5h7M8.5 14h4.5" />
                                            </svg>
                                        </button>
                                        <a className="vp-cap-btn vp-primary"
                                            aria-label={`Call ${profile.vendor_profile.contact_details.contact_name}`}
                                            href={`tel:${profile.vendor_profile.contact_details.contact_mbl}`}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M5 4h3.5l1.8 4.4-2.2 1.4a11 11 0 006.1 6.1l1.4-2.2L20 15.5V19a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />
                                            </svg>
                                        </a>
                                    </div>
                                </section>
                            )}

                            {/* ---------- about ---------- */}
                            {v?.vendor_about && (
                                <section data-rise="about" aria-labelledby="vp-about-h">
                                    <div className="vp-sec-h"><h2 id="vp-about-h">About</h2></div>
                                    <div className="vp-about">
                                        <p ref={descRef} className={`vp-desc${aboutOpen ? ' vp-open' : ''}`}>{v.vendor_about}</p>
                                        {aboutClamped && (
                                            <button className="vp-more" type="button" aria-expanded={aboutOpen}
                                                onClick={() => setAboutOpen((o) => !o)}>
                                                {aboutOpen ? 'less' : 'more'}
                                            </button>
                                        )}
                                    </div>
                                </section>
                            )}

{/* ---------- working hours (Figma node 101:246) ---------- */}
                            {workingHours.length > 0 && (
                                <section data-rise="hours">
                                    <div className="vp-hours-wrap" ref={hoursRef}>
                                        <div className="vp-hours-heading"><p>Working hours</p></div>
                                        <div className="vp-hours-card">

                                            <div className="vp-hours-today">
                                                <div className="vp-hours-text">
                                                    <p className="vp-hours-date">{todayLabel}</p>
                                                    <p className="vp-hours-range">
                                                        {closedToday
                                                            ? (todayHours?.day_status_msg || 'Closed today')
                                                            : (todayRange
                                                                ? `${fmtHour(todayRange.start)} – ${fmtHour(todayRange.end)}`
                                                                : (todayHours?.timing || '—'))}
                                                    </p>
                                                </div>
                                                <div className={`vp-hours-status${closedToday ? ' vp-is-closed' : ''}`}>
                                                    <img src={p_hours_dot} alt="" width="7" height="7" />
                                                    <p>
                                                        {closedToday
                                                            ? 'Closed today'
                                                            : (todayRange ? `Open · closes ${fmtHour(todayRange.end)}` : 'Open today')}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* the 24h track only renders when today's range could actually be parsed */}
                                            {!closedToday && todayRange && (
                                                <div className="vp-hours-timeline">
                                                    <div className="vp-hours-track">
                                                        <div className="vp-hours-rail" />
                                                        <div className="vp-hours-open" style={{
                                                            left: `${(todayRange.start / 24) * 100}%`,
                                                            width: `${((todayRange.end - todayRange.start) / 24) * 100}%`,
                                                        }} />
                                                        <img className="vp-hours-now" src={p_hours_now} alt="" width="18" height="18"
                                                            style={{ left: `calc(${nowFraction * 100}% - 9px)` }} />
                                                    </div>
                                                    <div className="vp-hours-ticks">
                                                        <p>12 AM</p><p>6 AM</p><p>12 PM</p><p>6 PM</p><p>12 AM</p>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="vp-hours-days">
                                                {weekStrip.map((d) => (
                                                    <div key={d.key}
                                                        className={`vp-hours-day${d.isToday ? (d.closed ? ' vp-day-today-closed' : ' vp-day-today') : ''}${!d.isToday && d.closed ? ' vp-day-closed' : ''}`}>
                                                        <p className="vp-day-letter">{d.letter}</p>
                                                        <p className="vp-day-date">{d.date}</p>
                                                        <p className="vp-day-tag">{d.isToday ? 'Today' : (d.closed ? 'Closed' : ' ')}</p>
                                                    </div>
                                                ))}
                                            </div>

                                            {hoursNote && (
                                                <div className="vp-hours-notes">
                                                    <img src={p_hours_check} alt="" width="16" height="16" />
                                                    <p>{hoursNote}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </section>
                            )}

                                                        {sheetOpen && (
                                <>
                                    <div className="vp-bs-overlay" ref={sheetOverlayRef} onClick={closeSheet} />
                                    <section className="vp-bsheet" ref={sheetRef} role="dialog" aria-modal="true" aria-label="Your bookings">
                                        <div className="vp-bs-handle" aria-hidden="true" />
                                        <div className="vp-bs-head">
                                            <h2>Your bookings</h2>
                                            <button type="button" className="vp-bs-close" onClick={closeSheet} aria-label="Close">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                                                    <path d="M6 6l12 12M18 6L6 18" />
                                                </svg>
                                            </button>
                                        </div>

                                        {historyRows === null && (
                                            <ul className="vp-list vp-bs-list" role="list">
                                                {[0, 1, 2].map((i) => (
                                                    <li key={i}><div className="vp-row">
                                                        <span className="vp-sk" style={{ width: 48, height: 48, borderRadius: 14 }} />
                                                        <span className="vp-txt" style={{ display: 'grid', gap: 6 }}>
                                                            <span className="vp-sk" style={{ height: 12, width: '55%' }} />
                                                            <span className="vp-sk" style={{ height: 12, width: '35%' }} />
                                                        </span>
                                                    </div></li>
                                                ))}
                                            </ul>
                                        )}

                                        {historyRows !== null && historyRows.length > 0 && (
                                            <ul className="vp-list vp-bs-list" role="list">
                                                {historyRows.map((r) => (
                                                    <li key={r.key}>
                                                        <button className="vp-row" type="button"
                                                            onClick={() => { closeSheet(); navigate(`/details/${r.id}`); }}>
                                                            <span className="vp-ic" style={r.kind === 'service'
                                                                ? { background: 'var(--vp-brand-50)', color: 'var(--vp-brand)' }
                                                                : { background: '#fff1e0', color: '#e8700f' }}>
                                                                {r.kind === 'service' ? ROW_ICON.membership : (
                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <path d="M6 7h12l1 14H5z" /><path d="M9 10V6a3 3 0 016 0v4" />
                                                                    </svg>
                                                                )}
                                                            </span>
                                                            <span className="vp-txt"><b>{r.title}</b><small>{r.when}</small></span>
                                                            {r.status && <span className={`vp-badge vp-st-${statusTone(r.status)}`}>{r.status}</span>}
                                                            {vpChevron}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                        {historyRows !== null && historyRows.length === 0 && (
                                            <div className="vp-bs-empty">
                                                <b>No bookings yet</b>
                                                <p>Your bookings at {v?.vendor_company_name || 'this store'} will show up here.</p>
                                            </div>
                                        )}

                                        <button className="vp-bs-all" type="button"
                                            onClick={() => { closeSheet(); navigate(`/history/${valueParam.vendor_id}`); }}>
                                            See all bookings {vpChevron}
                                        </button>
                                    </section>
                                </>
                            )}

                            <PingleFooter />
                        </div >

                        {showModal && <div className="modal-backdrop fade show" onClick={() => handleShow()} ></div>}

                        {
                            showModal && (

                                <div className="modal d-flex justify-content-center" tabIndex="-1" style={{ display: "block" }}>
                                    <div className="modal-dialog-centered loginWarningDialog" style={{ maxWidth: "360px" }}>
                                        <div className="modal-content">
                                            <div className="modal-body">
                                                <div className="ff-poppins-semiBold fs-16 primary-text text-center">
                                                    Attention!
                                                </div>
                                                <div className="ff-poppins-medium fs-13 text-center mt-2">
                                                    To proceed further please login and get the pingle experience.
                                                </div>
                                                <div className="d-flex justify-content-evenly mt-3" role="button" >
                                                    <div className="loginBtn text-light  primary-bg "
                                                        onClick={() => { localStorage.setItem('vendorUrl', location.pathname); navigate("/login", { state: { fromGuest: true } }) }}>
                                                        Login
                                                    </div>

                                                    <div className="loginBtn  primary-text primary-bg-light" onClick={handleShow}>
                                                        Close
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {/* {showModal &&
				<CenterLoginNavigateModal showModal={showModal} pathname={location.pathname} onclose={setShowModal(false)} />
			} */}

                    </> :
                    <>
                        <div className="p-3  scroller-style-y">

                            {/* Banner */}
                            <div className="  rounded bg-white" >

                            </div>
                            <Skeleton height={200} borderRadius={12} />

                            {/* Salon Details */}
                            <div className="mt-3 p-3 bg-white rounded">
                                <Skeleton width={180} height={25} />

                                <div className="mt-2">
                                    <Skeleton width={120} height={15} />
                                </div>

                                <div className="mt-2">
                                    <Skeleton width="90%" height={15} />
                                    <Skeleton width="80%" height={15} />
                                    <Skeleton width="60%" height={15} />
                                </div>

                                <div className="d-flex justify-content-between mt-4">
                                    <Skeleton width={80} height={40} />
                                    <Skeleton width={80} height={40} />
                                    <Skeleton width={80} height={40} />
                                </div>
                            </div>

                            {/* Captain Card */}
                            <div className="mt-3 p-3 rounded bg-white" >
                                <Skeleton width={120} height={18} />
                                <Skeleton width={90} height={18} className="mt-2" />

                                <div className="d-flex justify-content-between mt-3">
                                    <Skeleton width={140} height={45} borderRadius={10} />
                                    <Skeleton width={140} height={45} borderRadius={10} />
                                </div>
                            </div>

                            {/* Booking Cards */}
                            {[1, 2, 3].map((item) => (
                                <div key={item} className="mt-3 p-3 bg-white rounded">

                                    <Skeleton width={220} height={22} />

                                    <div className="mt-2">
                                        <Skeleton width="90%" height={15} />
                                        <Skeleton width="80%" height={15} />
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <Skeleton width={140} height={45} borderRadius={10} />
                                        <Skeleton width={140} height={45} borderRadius={10} />
                                    </div>

                                </div>
                            ))}

                        </div>
                    </>
            }

        </>
    )
}

export default VendorProfile












